/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsRoiaComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('LegsRoia').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/algu3d.glb',
            objectName: 'ROIA_SUPPORT',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('LegsRoia').attach(memoEval((self)=>[
            self.$diameter,
            self.$height
        ], ($diameter, $height)=>({
            morphTargetInfluences: {
                Diameter: {
                    value: $diameter,
                    scaleOne: 1800,
                    scaleZero: 1000
                },
                Height: {
                    value: $height,
                    scaleOne: 780,
                    scaleZero: 740
                }
            }
        })))
];

//# sourceMappingURL=legs-roia.js.map